import type { ReactNode } from 'react'

/**
 * The single owner of page max-width + gutters. Every screen on both surfaces
 * wraps in a Page, and the top bar aligns to the same cap, so header and body
 * share one edge. `width` opts a screen into the wider cap (boards, big tables);
 * omit it to inherit the surface default.
 */
export function Page({
  width,
  children,
}: {
  width?: 'default' | 'wide'
  children: ReactNode
}) {
  return (
    <div className="page" data-width={width}>
      {children}
    </div>
  )
}
